import gql from 'graphql-tag';

export const CREATE_SECTION = gql`
  mutation CreateSection($input: SectionInput!) {
    createSection(input: $input) {
      _id
    }
  }
`;

export const UPDATE_SECTION = gql`
  mutation UpdateSection($id: MOID!, $input: SectionUpdateInput!) {
    updateSection(id: $id, input: $input)
  }
`;

export const REMOVE_SECTION = gql`
  mutation RemoveSection($id: MOID!) {
    removeSection(id: $id)
  }
`;